export function getFullName(userObject) {
        return userObject.givenName + " " + userObject.surname;
}

export function getIDFromLink(link) {
        return link.substring(link.lastIndexOf('/') + 1);
}


/** WEBPACK FOOTER **
 ** ./src/app/utils/entityUtils.js
 **/